import type { FaireProductEntity } from "../../entity_types/product";

export const p_9ef2yrh93p: FaireProductEntity = {
  token: "p_9ef2yrh93p",
  type: "product",
  name: "Solid Button Down Front Pocket Knitted Long Cardigan",
  brandToken: "b_ssnpnu4tp4",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/dcf89926e67963888eeccac226f741dcc210125f51269bff3cdce68c3a128ffc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2103d521278a83e78020d46445c7913f405b67be6c44648dedd16aac4e4aedc4.jpeg",
    "https://cdn.faire.com/fastly/5ddcbb9d55e2231963b0ba459ca65f702aac370d587f749b1812872c674710b6.jpeg",
    "https://cdn.faire.com/fastly/9aa5611da072c5d48dad3804ab166c87eb214f4d7ba6f8f239d1692278077747.jpeg",
  ],
  priceDollars: 25.63,
  description:
    "Material: 100% Acrylic\nFeatures: Solid Button Down Front Pocket Knitted Long Cardigan\nOccasion: Casual/Daily/Outdoor/Vacation/Holiday/School/Going Out.\nStyle # EOSW510468",
  tags: [],
  msrpDollars: 51.26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:03.965Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
